import styled from '@emotion/styled';

export const DropdownContainer = styled.div`
  position: relative;
  border: 1px solid #babcbf;
  border-radius: 2px;
`;

export const DropdownButton = styled.button`
  display: flex;
  align-items: center;
  padding: 8px;
  background: none;
  cursor: pointer;

  svg {
    width: 16px;
    height: 12px;
  }
`;

export const DropdownContent = styled.div`
  position: relative;
`;

export const DropdownList = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  width: 393px;
  max-height: 253px;
  background: #FFF;
  border-radius: 2px;
  box-shadow: 0 0 8px 0 #ECEDF0;
  z-index: 1000;
  padding: 12px;
`;

export const OptionsList = styled.div`
  max-height: 195px;
  overflow-y: scroll;
  scrollbar-width: thin;
  margin-top: 5px;
`;
